import React from 'react'
import { connect } from 'react-redux';
import { getLoanApplicationId, getErrorMessage } from '../../../reducers'

import {
  loanApplicationUpdateStart
} from '../../../actions'

import ApplicantsForm from 'components/ApplicantsForm'
import ContinueButton from 'components/ContinueButton'

const canContinue = (state) => {
  let {
    applicant,
    secondaryValid,
  } = state
  return (applicant == 'primary') ? true : secondaryValid
}

class Applicants extends React.Component {
  state = {
    applicant: '',
    userName: '',
    userMobile: '',
    userEmail: '',
    secondaryValid: false,
    enabledContinue: false,
    errors: {}
  }

  componentDidUpdate(prevProps, prevState) {
    let errors = {}
    if (Object.keys(prevProps.errorMessage).length != Object.keys(this.props.errorMessage).length) {
      errors['userEmail'] = this.props.errorMessage.email
      this.setState({ errors })
    }
  }

  onContinueClick = () => {
    let {
      applicant,
      secondaryValid,
    } = this.state

    if (applicant === 'primary') {
      this.setState({ enabledContinue: false })
      this.props.loanApplicationUpdateStart({
        id: this.props.loanApplicationId,
        params: {
          application_form_pending: {
            applicant: applicant
          }
        }
      })
    } else {
      if (secondaryValid) {
        this.setState({ enabledContinue: false })
        this.props.loanApplicationUpdateStart({
          id: this.props.loanApplicationId,
          params: {
            application_form_pending: {
              applicant: applicant,
              firstname: this.state.userName,
              mobile: this.state.userMobile,
              email: this.state.userEmail
            }
          }
        })
      }
    }
  }

  onApplicantChange = (params) => {
    let newState = {
      ...this.state,
      ...params,
    }

    this.setState({
      ...newState,
      enabledContinue: canContinue(newState),
    })
  }

  // on this we do not want to validate errors on second applicant form.
  onApplicantNumberChange = (value) => {
    let newState = {
      ...this.state,
      applicant: value,
    }

    this.setState({
      applicant: value,
      enabledContinue: canContinue(newState),
    })
  }

  render() {
    const {
      applicant,
      userName,
      userMobile,
      userEmail,
      enabledContinue,
      errors,
    } = this.state

    return (
      <div>
        <h3 className="mb-3">Now it's time to learn more about you.</h3>

        <ApplicantsForm
          onSelectionChange={ (value) => this.onApplicantNumberChange(value) }
          onApplicantChange={ this.onApplicantChange }
          applicant={ applicant }
          userName={ userName }
          userMobile={ userMobile }
          userEmail={ userEmail }
          errors={ errors }
        />

        <div className="col text-right" >
          <div className="pull-right">
            <ContinueButton
              onClick={ this.onContinueClick }
              enabled={ enabledContinue }
            />
          </div>
          <div className="clearfix" />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  errorMessage: getErrorMessage(state),
  loanApplicationId: getLoanApplicationId(state)
});

export default connect(mapStateToProps, {
  loanApplicationUpdateStart
})(Applicants);
